import { render, staticRenderFns } from "./HospD.vue?vue&type=template&id=78c55cea&scoped=true"
import script from "./HospD.vue?vue&type=script&lang=js"
export * from "./HospD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c55cea",
  null
  
)

export default component.exports